export default "__VITE_ASSET__8MyHKIjD__"